"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFilm(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.213 1A1.79 1.79 0 0124 2.787v19.404a1.79 1.79 0 01-1.787 1.788H1.787A1.79 1.79 0 010 22.19V2.787A1.79 1.79 0 011.787 1zm0 1.532H1.787a.258.258 0 00-.255.255v19.404c0 .14.117.256.255.256h20.426a.258.258 0 00.255-.256V2.787a.258.258 0 00-.255-.255zM5.873 17.34c.422 0 .765.343.765.766v1.022a.766.766 0 01-.766.766H3.83a.766.766 0 01-.766-.766v-1.022c0-.423.343-.766.766-.766zm14.297 0c.423 0 .766.343.766.766v1.022a.766.766 0 01-.766.766h-2.042a.766.766 0 01-.766-.766v-1.022c0-.423.343-.766.766-.766zM5.872 13.255c.423 0 .766.343.766.766v1.022a.766.766 0 01-.766.766H3.83a.766.766 0 01-.766-.766V14.02c0-.423.343-.766.766-.766zm14.298 0c.423 0 .766.343.766.766v1.022a.766.766 0 01-.766.766h-2.042a.766.766 0 01-.766-.766V14.02c0-.423.343-.766.766-.766zM5.872 9.17c.423 0 .766.343.766.766v1.021a.766.766 0 01-.766.766H3.83a.766.766 0 01-.766-.766v-1.02c0-.424.343-.767.766-.767zm14.298 0c.423 0 .766.343.766.766v1.021a.766.766 0 01-.766.766h-2.042a.766.766 0 01-.766-.766v-1.02c0-.424.343-.767.766-.767zM5.872 5.085c.423 0 .766.343.766.766v1.021a.766.766 0 01-.766.766H3.83a.766.766 0 01-.766-.766v-1.02c0-.424.343-.767.766-.767zm14.298 0c.423 0 .766.343.766.766v1.021a.766.766 0 01-.766.766h-2.042a.766.766 0 01-.766-.766v-1.02c0-.424.343-.767.766-.767z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgFilm;
exports.default = _default;